<template>
  <div v-if="isSideMenuOpen" class="side-menu-wrapper">
    <div class="side-menu-background" @click="setIsSideMenuOpen(false)"></div>
    <b-container fluid class="side-menu">
      <b-row>
        <b-col cols="12" class="close-area">
          <div class="close-icon" @click="setIsSideMenuOpen(false)">
            <div class="close-icon-image"></div>
            <div class="close-icon-text">{{ $t('common.close') }}</div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="namako"
          :style="'background-image: url(' + namakoImage + ')'"
        ></b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="setting">
          <div class="setting-title">
            {{ $t('sideMenu.settings') }}
          </div>
          <div class="setting-select">
            <label>{{ $t('sideMenu.menuAppearance') }}</label>
            <select id="" v-model="selectedMenuDisplay" name="">
              <option value="2">{{ $t('sideMenu.menuLarge') }}</option>
              <option value="3">{{ $t('sideMenu.menuSmall') }}</option>
            </select>
          </div>
          <div v-if="!isUs" class="setting-select">
            <label>{{ $t('sideMenu.languageSettings') }}</label>
            <select v-model="selectedLanguage">
              <option v-for="(value, key) in languages" :key="key" :value="value.id">
                {{ value.name }}
              </option>
            </select>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="namako"
          :style="'background-image: url(' + namakoImage + ')'"
        ></b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="links">
          <div>
            <ul>
              <li v-if="!isJp" @click="handleTutorial">
                {{ $t('sideMenu.regardingSmartPhoneOrder') }}
              </li>
              <li v-if="false" @click="showQRForChildren()">
                {{ $t('sideMenu.showTheQrCodeAuthenticationForConnectingWithOtherSmartphones') }}
              </li>
              <li v-if="!(isTw || isCn)" class="allergen" @click="handleAllergenButtonClick">
                {{ $t('sideMenu.showAllergenInformation') }}
              </li>
            </ul>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="namako"
          :style="'background-image: url(' + namakoImage + ')'"
        ></b-col>
      </b-row>
      <b-row>
        <b-col cols="12" align-self="center">
          <div class="exit-button" @click="quitOrder()">
            <img src="@/assets/images/icn_caution.svg" alt="" />
            <div>{{ $t('sideMenu.closeTheOrderScreenWithTheSmartphone') }}</div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import config from '@/config/config'
import * as api from '@/api'
import namakoImage from '@/assets/images/bg_namako.svg'
export default {
  data() {
    return {
      selectedMenuDisplay: 0,
      languages: config.languages,
      selectedLanguage: '',
      playBikkurapon: true,
      namakoImage: namakoImage,
    }
  },
  computed: {
    ...mapGetters({
      lang: 'setting/getLanguage',
      shopId: 'seat/getShopId',
      seatNo: 'seat/getSeatNo',
      bikkurapon: 'setting/getBikkurapon',
      isSideMenuOpen: 'setting/getIsSideMenuOpen',
    }),
    showQrCode() {
      if (this.seatNo !== 0) {
        return true
      } else {
        return false
      }
    },
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isJp() {
      return this.defaultLanguage === 'ja'
    },
    isTw() {
      return this.defaultLanguage === 'zh-tw'
    },
    isCn() {
      return this.defaultLanguage === 'zh-cn'
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
  },
  watch: {
    selectedMenuDisplay(selectedMenuDisplay) {
      this.$store.dispatch('menu/setMenuDisplay', selectedMenuDisplay)
      this.selectedMenuDisplay = selectedMenuDisplay
    },
    selectedLanguage(newLanguage) {
      this.$i18n.locale = newLanguage
      api.instance.defaults.headers['Language-Id'] = newLanguage
      this.$store.dispatch('setting/setLanguage', newLanguage)
    },
    bikkurapon(newVal) {
      this.playBikkurapon = newVal
    },
  },
  mounted() {
    this.playBikkurapon = this.$store.getters['setting/getBikkurapon']
    this.selectedLanguage = this.languages.filter(
      (language) => language.id === this.$store.getters['setting/getLanguage']
    )[0].id
    this.selectedMenuDisplay = this.$store.getters['menu/getMenuDisplay']
  },
  methods: {
    ...mapActions({
      setIsSideMenuOpen: 'setting/setIsSideMenuOpen',
    }),
    handleTutorial() {
      this.$store.dispatch('modal/setShowingTutorialModal', true)
    },
    quitOrder() {
      this.$store.dispatch('modal/setShowingOrderQuittingModal', true)
    },
    showQRForChildren() {
      api
        .fetchQr(this.shopId, this.seatNo)
        .then((response) => {
          this.$store.dispatch('modal/setShowingQRForChildrenModal', true)
          this.$store.dispatch('setting/setChildrenQr', response.data.childrenQr)
        })
        .catch(() => {
          this.$store.dispatch('modal/setShowingSimpleErrorModal', true)
        })
    },
    settingPlayBikkurapon(bool) {
      api
        .enableBikkurapon(this.shopId, this.seatNo, bool)
        .then(() => {
          this.$store.dispatch('setting/setBikkurapon', bool)
        })
        .catch(() => {
          this.playBikkurapon = !bool
        })
    },
    handleAllergenButtonClick() {
      if (this.isApp) {
        window.location.href = `${process.env.VUE_APP_BASE_CUSTOM_SCHEME}/open/kura_allergen`
      } else if (this.isUs) {
        window.open('https://kurasushi.com/menu/allergen-information/')
      } else {
        window.open('https://www.kurasushi.co.jp/app/app_allergen.html')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.side-menu-wrapper {
  position: fixed;
  top: 0;
  width: 100%;
  height: 110vh;
  z-index: 200;
}
.side-menu-background {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.side-menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 280px;
  height: 100%;
  background-color: #343434;
  color: #fff;
  overflow-y: auto;
}
.close-area {
  display: flex;
  box-sizing: border-box;
  padding: 10px 10px !important;
}
.close-icon {
  display: flex;
  flex-direction: column;
  margin-left: auto;

  &-text {
    font-size: 10px;
    text-align: center;
  }
  &-image {
    display: block;
    position: relative;
    margin: 0 auto;
    padding: 0;
    width: 2px;
    height: 20px;
    background: #fff;
    transform: rotate(45deg);

    &:before {
      display: block;
      content: '';
      position: absolute;
      top: 50%;
      left: -9px;
      width: 20px;
      height: 2px;
      margin-top: -1px;
      background: #fff;
    }
  }
}
.setting {
  box-sizing: border-box;
  padding: 10px 20px !important;
  &-title {
    font-size: 1rem;
    text-align: left;
  }
}
.col-12 {
  padding: 0;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 1rem;
    box-sizing: border-box;
    padding: 15px 20px;
    // for iphone5/SE
    @media screen and (max-width: 375px) {
      height: 40px;
      font-size: 0.9rem;
      line-height: 40px;
    }
  }
  li:not(:last-child) {
    border-bottom: 1px solid #5a5a5a;
  }
}
.setting-select {
  text-align: left;
  border: 1px solid #5a5a5a;
  border-radius: 5px;
  margin: 15px 0;
  position: relative;
  background-color: #404040;
  padding: 10px 15px;
  // for iphone5/SE
  @media screen and (max-width: 375px) {
    padding: 5px 15px;
  }
  &:last-child {
    margin-bottom: 5px;
  }
  label {
    font-weight: bold;
    font-size: 1rem;
    margin-bottom: 0 !important;
    @media screen and (max-width: 375px) {
      font-size: 0.8rem;
    }
  }
  select {
    position: absolute;
    width: 100%;
    display: block;
    top: 10px;
    left: 0;
    outline: none;
    background: transparent;
    border: none;
    color: #fff;
    appearance: none;
    box-sizing: border-box;
    padding-left: calc(100% - 5rem);
    @media screen and (max-width: 375px) {
      font-size: 0.8rem;
    }
  }
}
.links {
  margin: 5px 0;
}
a,
a:active,
a:hover,
a:focus {
  color: white;
  border-bottom: none;
  text-decoration: none;
}
.namako {
  height: 6px;
  background-size: contain;
}
.exit-button {
  display: flex;
  align-items: center;
  margin: 15px auto 50px;
  background-color: #e6e6e6;
  color: #222222;
  width: 80%;
  border-bottom: 2px solid #bfbfbf;
  border-radius: 5px;
  line-height: 1.33;
  text-align: left;
  &:active {
    border-bottom: none;
    margin-top: 12px;
  }
  > img {
    padding: 0 10px;
  }
  > div {
    padding: 10px 0;
    font-size: 14px;
    vertical-align: middle;
  }
}
</style>
